import { EntityTypes } from '@/constants/entityTypes'
import { Permissions } from '@/constants/permissionEnums'
import { useTranslation } from '@/features/shared/composables/useTranslation'

const t = useTranslation()

export const entityRoutes = [
  {
    path: 'brands/:entityId/analytics',
    name: 'EntityAnalytics',
    component: () => import('@/views/Entities/EntityAnalytics.vue'),
    meta: {
      mainRouteName: 'Entities',
      title: `${t('analytics')} | Pour Now`,
      permissionIdentifiers: [Permissions.CAN_VIEW_LISTING_ANALYTICS],
      visibleEntityTypes: [EntityTypes.BRAND],
    },
  },
]
